const Events = () => {
  return <div className="eventswrapper"></div>;
};
export default Events;
